const TABLE_SAVE_PATH = /^\/admin\/rich_text_tables(?:\/\d+)?$/;

function widthControls(editorElement) {
  const toolbar = editorElement.toolbarElement;
  if (!toolbar) return null;

  const panel = toolbar.querySelector(".cs2n-trix-table-editor");
  if (!panel) return null;

  let controls = panel.querySelector(".cs2n-trix-table-editor__width");
  if (controls) return controls;

  controls = document.createElement("div");
  controls.className = "cs2n-trix-table-editor__width";
  controls.innerHTML = `
    <label>
      Table width
      <select data-table-width-mode>
        <option value="full">Full width</option>
        <option value="custom">Custom width</option>
      </select>
    </label>
    <label data-table-width-value-wrap>
      Width
      <input type="number" min="1" max="100" value="75" data-table-width-value>
    </label>
    <label data-table-width-unit-wrap>
      Unit
      <select data-table-width-unit>
        <option value="%">%</option>
        <option value="px">px</option>
      </select>
    </label>
  `;

  const colors = panel.querySelector(".cs2n-trix-table-editor__colors");
  if (colors) colors.insertAdjacentElement("afterend", controls);
  else panel.insertBefore(controls, panel.querySelector(".cs2n-trix-table-editor__grid"));

  controls.addEventListener("change", () => updateWidthControlState(controls));
  controls.addEventListener("input", () => updateWidthControlState(controls));
  updateWidthControlState(controls);
  return controls;
}

function updateWidthControlState(controls) {
  const mode = controls.querySelector("[data-table-width-mode]").value;
  const unit = controls.querySelector("[data-table-width-unit]").value;
  const value = controls.querySelector("[data-table-width-value]");
  const disabled = mode !== "custom";

  value.disabled = disabled;
  controls.querySelector("[data-table-width-unit]").disabled = disabled;
  value.max = unit === "%" ? "100" : "2400";

  if (unit === "%" && parseInt(value.value, 10) > 100) value.value = "100";
}

function setWidthControls(editorElement, layout) {
  const controls = widthControls(editorElement);
  if (!controls) return;

  const custom = layout && layout.mode === "custom";
  const unit = custom && layout.unit === "px" ? "px" : "%";
  const fallback = unit === "%" ? 75 : 800;
  const max = unit === "%" ? 100 : 2400;
  const parsed = parseInt(layout && layout.width, 10);
  const value = Math.min(Math.max(parsed || fallback, 1), max);

  controls.querySelector("[data-table-width-mode]").value = custom ? "custom" : "full";
  controls.querySelector("[data-table-width-unit]").value = unit;
  controls.querySelector("[data-table-width-value]").value = value;
  updateWidthControlState(controls);
}

function layoutFromControls(editorElement) {
  const controls = widthControls(editorElement);
  if (!controls) return { mode: "full" };

  const mode = controls.querySelector("[data-table-width-mode]").value;
  if (mode !== "custom") return { mode: "full" };

  const unit = controls.querySelector("[data-table-width-unit]").value === "px" ? "px" : "%";
  const max = unit === "%" ? 100 : 2400;
  const value = Math.min(Math.max(parseInt(controls.querySelector("[data-table-width-value]").value, 10) || 1, 1), max);
  return { mode: "custom", width: value, unit };
}

function layoutFromFigure(figure) {
  try {
    const wrapper = figure.querySelector("[data-rich-text-table]");
    if (!wrapper) return { mode: "full" };
    const data = JSON.parse(wrapper.dataset.richTextTable || "{}");
    return data.layout || { mode: "full" };
  } catch (_error) {
    return { mode: "full" };
  }
}

function visibleTableEditor() {
  return Array.from(document.querySelectorAll("trix-editor")).find((editorElement) => {
    const panel = editorElement.toolbarElement && editorElement.toolbarElement.querySelector(".cs2n-trix-table-editor");
    return panel && !panel.hidden;
  });
}

document.addEventListener("trix-initialize", (event) => widthControls(event.target));

document.addEventListener("trix-action-invoke", (event) => {
  if (event.actionName !== "x-table") return;
  window.setTimeout(() => setWidthControls(event.target, { mode: "full" }), 0);
});

document.addEventListener("dblclick", (event) => {
  const figure = event.target.closest("figure.attachment");
  const editorElement = event.target.closest("trix-editor");
  if (!figure || !editorElement || !figure.querySelector("[data-rich-text-table]")) return;
  const layout = layoutFromFigure(figure);
  window.setTimeout(() => setWidthControls(editorElement, layout), 0);
});

const originalFetch = window.fetch.bind(window);
window.fetch = function(input, init) {
  const url = typeof input === "string" ? input : input.url;
  const method = ((init && init.method) || "GET").toUpperCase();
  const contentType = init && init.headers && (init.headers["Content-Type"] || init.headers.get && init.headers.get("Content-Type"));

  if ((method === "POST" || method === "PATCH") && TABLE_SAVE_PATH.test(url) && contentType === "application/json" && init && init.body) {
    try {
      const body = JSON.parse(init.body);
      const editorElement = visibleTableEditor();
      if (body.rich_text_table && editorElement) {
        body.rich_text_table.layout = layoutFromControls(editorElement);
        init = Object.assign({}, init, { body: JSON.stringify(body) });
      }
    } catch (_error) {
      // Let the original request proceed unchanged.
    }
  }

  return originalFetch(input, init);
};
